import { HelpPageContent } from 'components/help_sidebar';
import { FormattedMessage } from 'react-intl';

const strong = (chunks: React.ReactNode) => (
    <strong>
        {chunks}
    </strong>
);

export const helpContent: HelpPageContent = {
    segments: [
        {
            body: (
                <p>
                    <FormattedMessage defaultMessage="This page shows all licenses currently in your inventory, including <strong>quantities available</strong>, <strong>ordering dates</strong>, and <strong>expiration dates</strong>." id="this_page_shows_all_licenses_currently_i.722cb02c" values={{ strong }} />
                </p>
            ),
            title: <FormattedMessage defaultMessage="Viewing Inventory" id="viewing_inventory.c3108ed1" />
        },
        {
            body: (
                <p>
                    <FormattedMessage defaultMessage="Click <strong>Export</strong> to download your inventory data as a spreadsheet for offline review or reporting." id="click_export_to_download_your_inventory.6cd5dbf0" values={{ strong }} />
                </p>
            ),
            title: <FormattedMessage defaultMessage="Exporting Data" id="exporting_data.ec77bfb8" />
        },
        {
            body: (
                <p>
                    <FormattedMessage defaultMessage="Click <strong>Order More Inventory</strong> to place a new order and replenish your stock of available licenses." id="click_order_more_inventory_to_place_a_ne.7c23e37d" values={{ strong }} />
                </p>
            ),
            title: <FormattedMessage defaultMessage="Ordering More" id="ordering_more.b8b278ac" />
        }
    ],
    title: <FormattedMessage defaultMessage="My Inventory" id="my_inventory.21568e1d" />
};
